export const MAX_PAGE_SIZE = 9999
